export default (palette) => ({
  root: {
    padding: '10px 16px',
    borderRadius: '10px',
    margin: '4px 8px', // Spacing suave para cards de menu elevados ✨
    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      backgroundColor: palette.type === 'dark' 
        ? 'rgba(255, 255, 255, 0.05)' 
        : 'rgba(0, 0, 0, 0.04)',
      transform: 'translateX(4px)', // O micro-destaque elegante solicitado! 🛸⚡
    },
  }
})
